'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

var _AbstractField2 = require('./AbstractField');

var _AbstractField3 = _interopRequireDefault(_AbstractField2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StringField = function (_AbstractField) {
    (0, _inherits3.default)(StringField, _AbstractField);

    function StringField() {
        (0, _classCallCheck3.default)(this, StringField);
        return (0, _possibleConstructorReturn3.default)(this, (StringField.__proto__ || (0, _getPrototypeOf2.default)(StringField)).apply(this, arguments));
    }

    (0, _createClass3.default)(StringField, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                addonsBefore = _props.addonsBefore,
                addonsAfter = _props.addonsAfter,
                props = (0, _objectWithoutProperties3.default)(_props, ['addonsBefore', 'addonsAfter']);


            var field = _react2.default.createElement(_reactstrap.Input, (0, _extends3.default)({
                type: 'text'
            }, props));

            return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
        }
    }]);
    return StringField;
}(_AbstractField3.default);

exports.default = StringField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZmllbGQvU3RyaW5nRmllbGQuanN4Il0sIm5hbWVzIjpbIlN0cmluZ0ZpZWxkIiwicHJvcHMiLCJhZGRvbnNCZWZvcmUiLCJhZGRvbnNBZnRlciIsImZpZWxkIiwicmVuZGVyRmllbGRXaXRoQWRkb25zIiwiQWJzdHJhY3RGaWVsZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUNBOzs7O0FBQ0E7O0FBQ0E7Ozs7OztJQUVNQSxXOzs7Ozs7Ozs7O2lDQUVPO0FBQUEseUJBQ3lDLEtBQUtDLEtBRDlDO0FBQUEsZ0JBQ0VDLFlBREYsVUFDRUEsWUFERjtBQUFBLGdCQUNnQkMsV0FEaEIsVUFDZ0JBLFdBRGhCO0FBQUEsZ0JBQ2dDRixLQURoQzs7O0FBR0wsZ0JBQU1HLFFBQVEsOEJBQUMsaUJBQUQ7QUFDVixzQkFBSztBQURLLGVBRU5ILEtBRk0sRUFBZDs7QUFLQSxtQkFBTyxLQUFLSSxxQkFBTCxDQUEyQkQsS0FBM0IsRUFBa0NGLFlBQWxDLEVBQWdEQyxXQUFoRCxDQUFQO0FBQ0g7OztFQVhxQkcsdUI7O2tCQWNYTixXIiwiZmlsZSI6IlN0cmluZ0ZpZWxkLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQge0lucHV0fSBmcm9tICdyZWFjdHN0cmFwJ1xuaW1wb3J0IEFic3RyYWN0RmllbGQgZnJvbSBcIi4vQWJzdHJhY3RGaWVsZFwiO1xuXG5jbGFzcyBTdHJpbmdGaWVsZCBleHRlbmRzIEFic3RyYWN0RmllbGQge1xuXG4gICAgcmVuZGVyKCkge1xuICAgICAgICBjb25zdCB7YWRkb25zQmVmb3JlLCBhZGRvbnNBZnRlciwgLi4ucHJvcHN9ID0gdGhpcy5wcm9wcztcblxuICAgICAgICBjb25zdCBmaWVsZCA9IDxJbnB1dFxuICAgICAgICAgICAgdHlwZT1cInRleHRcIlxuICAgICAgICAgICAgey4uLnByb3BzfVxuICAgICAgICAvPjtcblxuICAgICAgICByZXR1cm4gdGhpcy5yZW5kZXJGaWVsZFdpdGhBZGRvbnMoZmllbGQsIGFkZG9uc0JlZm9yZSwgYWRkb25zQWZ0ZXIpO1xuICAgIH1cbn1cblxuZXhwb3J0IGRlZmF1bHQgU3RyaW5nRmllbGQ7XG4iXX0=